// leadScores.ts — MCC intelligence. The lead-scoring queue client: run the
// scorer, list the ranked leads, fetch one profile's score card.

import { request } from './request'

export interface LeadScoreRow {
  profile_id: string
  score: number
  fit_score: number
  readiness_score: number
  confidence: string
  tier: string
  reasoning: string | null
  scored_at: string
  first_name: string | null
  last_name: string | null
  email_primary: string | null
  lifecycle_stage: string
  lead_source: string | null
}

export const leadScoresApi = {
  run: () =>
    request<{ ok: boolean; scored: number; changed: number; candidates: number }>(
      '/api/admin/lead-scores/run',
      { method: 'POST', body: '{}' },
    ),

  list: (filters: { tier?: string; min_score?: number } = {}) => {
    const p = new URLSearchParams()
    if (filters.tier) p.set('tier', filters.tier)
    if (typeof filters.min_score === 'number') p.set('min_score', String(filters.min_score))
    const qs = p.toString()
    return request<{ ok: boolean; leads: LeadScoreRow[]; limit: number }>(
      `/api/admin/lead-scores${qs ? `?${qs}` : ''}`,
    )
  },

  get: (profileId: string) =>
    request<{ ok: boolean; score: Record<string, unknown> }>(
      `/api/admin/lead-scores/${encodeURIComponent(profileId)}`,
    ),
}
